import React from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { RightSidebar } from '@/components/ui/RightSidebar';
import MarkdownReader from '@/components/ui/MarkdownReader';
import { useInfoPanelStore } from '@/stores/infoPanelStore';
import { FIELD_EXPLANATIONS } from '@/config/fieldExplanations';

export const InfoPanelRoot: React.FC = () => {
  const { t } = useTranslation();
  const { isOpen, topicKey, close } = useInfoPanelStore(
    useShallow((s) => ({ isOpen: s.isOpen, topicKey: s.topicKey, close: s.close })),
  );

  const meta = topicKey ? FIELD_EXPLANATIONS[topicKey] : null;

  return (
    <RightSidebar
      title={meta ? t(meta.titleKey) : ''}
      isVisible={isOpen}
      onClose={close}
    >
      <div className="p-4">
        {meta && <MarkdownReader content={t(meta.contentKey)} variant="compact" />}
      </div>
    </RightSidebar>
  );
};
